module.exports = __webpack_public_path__ + "ATS/img/icon_time.37985196.svg";